import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { productAttributesStyles } from "@dana/Overrides/Components/ProductAttributes";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productAttributesStyles.container = mergeToNew(productAttributesStyles.container, {
    css: css`
        margin-top: 16px;
        width: 100%;

        &.with-add-to-cart {
            margin-top: auto;
        }
    `,
});

productAttributesStyles.attributeValueGridItem = mergeToNew(productAttributesStyles.attributeValueGridItem, {
    css: css`
        &:not(:last-child) {
            margin-bottom: 8px;
        }
    `,
});

productAttributesStyles.specAccordionSection = mergeToNew(productAttributesStyles.specAccordionSection, {
    headerProps: {
        css: css`
            width: 100%;

            button {
                border: 1px solid ${themeBackgrounds.lightGray};
                &,
                &:focus-visible,
                &:focus {
                    padding: 8px;
                    background: ${themeColors.primary.white};
                }

                &:hover {
                    background: ${themeBackgrounds.lightGray};
                }

                &[aria-expanded="true"] {
                    background: ${themeBackgrounds.lightGray};
                }

                ${IconWrapper} {
                    &,
                    & svg {
                        width: 16px;
                        height: 16px;
                    }
                }

                &:not([aria-expanded="true"]) {
                    &:hover {
                        background: ${themeBackgrounds.lightGray};
                    }
                }

                ${TypographyStyle} {
                    font-size: ${fontSizes.medium};
                    line-height: ${lineHeights.defaultLarge};
                    font-weight: ${fontWeights.semiBold};
                }
            }
        `,
    },
    panelProps: {
        css: css`
            width: 100%;
            padding: 8px;
        `,
    },
});
